import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { z } from "zod"

import ContactContainer from "@/screens/Companies/edit/components/contacts/ContactContainer"

const SearchParamsValidator = z.object({
  query: z.string().optional(),
  isActive: z.boolean().nullish(),
  isPrimaryContact: z.boolean().nullish(),
  locationIds: z.array(z.string()).optional(),
  companyDepartments: z.array(z.string()).optional(),
  contactSubscriptions: z.array(z.string()).optional(),
})

export const Route: AnyRoute = createFileRoute("/app/companies/$companyId/edit/_layout/contacts")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [
      retainSearchParams([
        "query",
        "isActive",
        "isPrimaryContact",
        "locationIds",
        "companyDepartments",
        "contactSubscriptions",
      ]),
    ],
  },
  component: ContactContainer,
})
